import { Box } from "@mui/material";

interface ChartTableWrapperProps {
  children: React.ReactNode;
  small?: boolean;
}

const ChartTableWrapper = ({ children, small }: ChartTableWrapperProps) => (
  <Box
    width={"100%"}
    height={`calc(100vh - ${small ? 300 : 165}px)`}
    pb={1}
    // todo: check if this is needed
    sx={{ overflowY: "auto" }}
  >
    {children}
  </Box>
);

export default ChartTableWrapper;
